import $foreign from "./foreign.cjs";
var _setAttributes = $foreign._setAttributes;
var addEventListenerImpl = $foreign.addEventListenerImpl;
var appendChildImpl = $foreign.appendChildImpl;
var appendRawHtmlImpl = $foreign.appendRawHtmlImpl;
var createDocumentFragmentImpl = $foreign.createDocumentFragmentImpl;
var createElementImpl = $foreign.createElementImpl;
var createElementNSImpl = $foreign.createElementNSImpl;
var createTextNodeImpl = $foreign.createTextNodeImpl;
var innerHTML = $foreign.innerHTML;
var insertBeforeImpl = $foreign.insertBeforeImpl;
var moveAllBetweenInclusiveImpl = $foreign.moveAllBetweenInclusiveImpl;
var parentNodeImpl = $foreign.parentNodeImpl;
var preventDefault = $foreign.preventDefault;
var removeAllBetweenImpl = $foreign.removeAllBetweenImpl;
var removeAttributesImpl = $foreign.removeAttributesImpl;
var removeNode = $foreign.removeNode;
var setTextImpl = $foreign.setTextImpl;
export { _setAttributes, addEventListenerImpl, appendChildImpl, appendRawHtmlImpl, createDocumentFragmentImpl, createElementImpl, createElementNSImpl, createTextNodeImpl, innerHTML, insertBeforeImpl, moveAllBetweenInclusiveImpl, parentNodeImpl, preventDefault, removeAllBetweenImpl, removeAttributesImpl, removeNode, setTextImpl };
